class CarouselComponent extends HTMLElement {
  constructor() {
    super();
    this.carousel = this.querySelector('[id^="Carousel-"]');
    this.carouselItems = this.querySelectorAll('[id^="Carousel-Item-"]');
    this.currentPageElement = this.querySelector('.carousel-counter--current');
    this.pageTotalElement = this.querySelector('.carousel-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.isDown = false;

    if (!this.carousel || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.carousel);

    this.carousel.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    const carouselItemArray = [...this.carouselItems];
    this.carouselItemsToShow = carouselItemArray.filter(
      element => element.clientWidth > 0
    );

    if (this.carouselItemsToShow.length < 2) return;
    this.carouselItemOffset =
      this.carouselItemsToShow[1].offsetLeft -
      this.carouselItemsToShow[0].offsetLeft;
    this.carouselItemsPerPage = Math.floor(
      (this.carousel.clientWidth - this.carouselItemsToShow[0].offsetLeft) /
        this.carouselItemOffset
    );
    this.totalPages =
      this.carouselItemsToShow.length - this.carouselItemsPerPage + 1;
    this.update();
  }

  resetPages() {
    this.carouselItems = this.querySelectorAll('[id^="Carousel-Item-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.carousel.scrollLeft / this.carouselItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.carouselItemsToShow[this.currentPage - 1]
          }
        })
      );
    }

    if (
      this.isSlideVisible(this.carouselItemsToShow[0]) &&
      this.carousel.scrollLeft === 0
    ) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (
      this.carousel.scrollLeft + this.carousel.offsetWidth ===
      this.carousel.scrollWidth
    ) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    if (element) {
      const lastVisibleSlide =
        this.carousel.clientWidth + this.carousel.scrollLeft - (offset || 0);
      return (
        element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
        element.offsetLeft >= this.carousel.scrollLeft
      );
    }
    return false;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.carousel.scrollLeft + step * this.carouselItemOffset
        : this.carousel.scrollLeft - step * this.carouselItemOffset;
    this.carousel.scrollTo({
      left: this.slideScrollPosition,
      behavior: 'smooth'
    });
  }

  startDrag(event) {
    this.isDown = true;
    setTimeout(() => {
      this.carousel.classList.add('is-dragging');
    }, 100);
    this.startX = event.pageX - this.carousel.offsetLeft;
    this.scrollLeft = this.carousel.scrollLeft;
  }
  endDrag() {
    this.isDown = false;
    this.carousel.classList.remove('is-dragging');
  }
  onDrag(event) {
    if (!this.isDown) return;
    event.preventDefault();
    const x = event.pageX - this.carousel.offsetLeft;
    const walk = (x - this.startX) * 1; //scroll speed
    this.carousel.scrollLeft = this.scrollLeft - walk;
  }
}

customElements.define('carousel-component', CarouselComponent);

class TabbedCarouselComponent extends CarouselComponent {
  constructor() {
    super();
    this.tabMenu = this.querySelector('[id^="Tabs-"]');
    this.tabMenuItems = this.querySelectorAll('[id^="Tab-"]');
    // this.lastMenuItem = this.querySelector('[id^="Tab-"]:last-child');

    this.tabMenuItems.forEach(item =>
      item.addEventListener('click', this.onTabClick.bind(this))
    );
  }

  update() {
    const trendingNavContainer = this.querySelector('.headerTrending');
    this.carouselItems.forEach(item => {
      if (item.classList.contains('carousel__item--card')) {
        if (item.getBoundingClientRect().left <= 180) {
          if (this.tabMenuItems) {
            this.tabMenuItems.forEach(item =>
              item.classList.remove('is-active')
            );
            const id = item.id.split('Carousel-Item-')[1];
            const currentMenuItem = this.querySelector(`#Tab-${id}`);
            currentMenuItem.classList.add('is-active');
            const rect = currentMenuItem.getBoundingClientRect();

            // Check if currentMenuItem is partially hidden in the viewport
            const isPartiallyHiddenRightWindow = rect.right > window.innerWidth;
            const isPartiallyHiddenLeftWindow = rect.left < 0;
            if (window.innerWidth < 768) {
              if (isPartiallyHiddenRightWindow) {
                trendingNavContainer.scrollLeft +=
                  rect.right - (window.innerWidth - 32);
              }
              if (isPartiallyHiddenLeftWindow) {
                trendingNavContainer.scrollLeft += rect.left - 32;
              }
            }
          }
        }
      }
    });
    super.update();
  }
  onTabClick(event) {
    event.preventDefault();
    const id = event.target.id.split('Tab-')[1];
    const page = this.querySelector(`#Carousel-Item-${id}`);
    this.carousel.scrollTo({
      left: page.offsetLeft,
      behavior: 'smooth'
    });
  }
}

customElements.define('tabbed-carousel-component', TabbedCarouselComponent);

class ProductCard extends HTMLElement {
  // Specify observed attributes so that attributeChangedCallback fires
  static get observedAttributes() {
    return ['product', 'gql-product', 'color'];
  }

  constructor() {
    super();

    this.addToCart = this.addToCart.bind(this);
    this._gqlProduct = false;
    this._product = null;
    this._selectedColor = null;
    const collectionsAttr = this.getAttribute('collections');
    this._productCollections = JSON.parse(collectionsAttr);
  }
  set selectedColor(color) {
    this._selectedColor = color;
    this.addProductOptions();
  }
  get selectedColor() {
    return this._selectedColor;
  }
  attributeChangedCallback(attr, oldVal, newVal) {
    if (newVal === 'null' || newVal === 'undefined') return;
    if (oldVal !== newVal) {
      if (['product', 'gql-product'].includes(attr)) {
        let product =
          attr === 'gql-product'
            ? mapGqlProductToProduct(JSON.parse(newVal))
            : JSON.parse(newVal);
        this._product = product;
      }
      if (['color'].includes(attr)) {
        this._selectedColor = newVal;
      }
      if (this._product) {
        // console.log(`product object => ${JSON.stringify(this._product, 0, 2)}`);
        this.addColorSwatches();
        this.addPromoTags();
        this.addProductOptions();
      }
    }
  }
  addPromoTags() {
    if (
      !this._product ||
      !this._product.tags ||
      !this._product.tags.includes('waitlist')
    )
      return;

    // select the promo tags for styling and checking against future tags
    let globalPromoTags;
    try {
      globalPromoTags = JSON.parse(
        document.getElementById('promo-tag-manager-json').innerHTML
      ).promoTags;
    } catch (e) {
      console.warn("Can't set promoTags.");
      return;
    }

    const waitlistTag = globalPromoTags.find(
      tag => tag.relatedTag === 'waitlist'
    );
    if (!waitlistTag) return;

    const waitlistTagMarkup = `<div
        class="promo-tag"
        style="color: ${waitlistTag.textColor}; background-color: ${waitlistTag.backgroundColor};"
    >
        ${waitlistTag.label}
    </div>`;

    this.querySelector('.product-card__tag').innerHTML = waitlistTagMarkup;
  }

  addColorSwatches() {
    // Check for tags that should disable colors
    if (
      !this._product ||
      !this._product.tags ||
      this._product.tags.includes('hide_quick_colors')
    )
      return;
    const colorOptionIndex = this._product.options.findIndex(
      option => option.toLowerCase() === 'color'
    );

    if (colorOptionIndex < 0) return;
    const colorOption = `option${colorOptionIndex + 1}`;
    let colors = [
      ...new Set(this._product.variants.map(variant => variant[colorOption]))
    ];
    // remove discontinued variants swatches
    colors = colors.filter(
      color => !color.toLowerCase().includes('discontinued')
    );
    const colorSwatches = colors.map(color => {
      if (!this._selectedColor) this.selectedColor = color;
      return `
        <a role="button" aria-label="preview in ${color}" title="${color}" class="swatch ${slugify(
        color
      )} ${
        this._selectedColor === color ? 'active' : ''
      }" data-color="${color}"><span class="swatch-color-square"></span></a>
      `;
    });
    let colorImages = {};
    let colorIds = {};
    colors.forEach(color => {
      const colorVariant = this._product.variants.find(variant =>
        variant.title.includes(color)
      );
      // match the colors to their featured image
      if (colorVariant?.featured_image?.src) {
        colorImages[color] = colorVariant?.featured_image?.src;
      }
      // match the colors to their variant id
      if (colorVariant) {
        colorIds[color] = colorVariant.id;
      }
    });
    const productImageLink = this.querySelector('.product-card__image');
    const productName = this.querySelector('.product-card__title').innerText;
    if (colorSwatches.length > 4) {
      this.querySelector('.product-card__colors').innerHTML =
        colorSwatches.join('') +
        `<a href="${productImageLink.href}" aria-label="Visit ${productName} product page" class="more-colors">
        <span class="more-colors-caret">>
        </span>
        </a>`;
    } else {
      this.querySelector('.product-card__colors').innerHTML =
        colorSwatches.join('');
    }
    this.querySelectorAll('.swatch').forEach(swatch =>
      swatch.addEventListener('click', e => {
        this.querySelectorAll('.swatch').forEach(swatch =>
          swatch.classList.remove('active')
        );
        e.target.closest('.swatch').classList.add('active');
        this.selectedColor = e.target.closest('.swatch').dataset.color;

        this.querySelector('.product-card__image img').src =
          colorImages[e.target.closest('.swatch').dataset.color];
        this.querySelector('.product-card__image img').srcset =
          colorImages[e.target.closest('.swatch').dataset.color];

        // Update the product card link with the variant id
        // handles algolia product cards and regular product cards by just swapping the variant id
        productImageLink.href = productImageLink.href.replace(
          /variant=\d+/,
          `variant=${colorIds[this.selectedColor]}`
        );
      })
    );
  }
  addProductOptions() {
    // Check for tags that should disable quick options
    if (!this._product || !this._product.tags) return;
    if (
      this._product.tags.includes('product-bundle') ||
      this._product.tags.includes('hide_quick_cart') ||
      this._product.tags.includes('printful-custom')
    )
      return;
    let optionButtons = [];

    const hasOneSizeOption = this._product.variants.every(
      variant =>
        variant.options.includes('One Size') ||
        variant.title.includes('One Size')
    );
    const onlyHasColorOption =
      this._product.options.length === 1 &&
      this._product.options.includes('Color');
    // If single variant or uses One Size use Add To Bag
    if (this._product.variants.length === 1) {
      const variant = this._product.variants[0];
      if (variant.available) {
        const desktopATCButton = `
          <a role="button" title="add to bag" aria-label="add to bag" class="add-to-cart" data-product-title="${
            this._product.title
          }" data-product-price="${(this._product.price / 100).toFixed(
          2
        )}" data-variant-id="${
          variant.id
        }" data-option data-available="true">Add To Bag</a>
        `;
        const mobileATCButton = `
          <a role="button" title="add to bag" aria-label="add to bag" class="add-to-cart" data-product-title="${
            this._product.title
          }" data-product-price="${(this._product.price / 100).toFixed(
          2
        )}" data-variant-id="${
          variant.id
        }" data-option data-available="true">+</a>
        `;
        optionButtons.push(desktopATCButton);
        // desktop
        this.querySelector('.product-card__options').innerHTML =
          desktopATCButton;
        // mobile < 768px
        this.querySelector('.product-card__cta').innerHTML = mobileATCButton;
      }
    } else {
      let variants = this._product.variants;
      let sizeOptionIndex = this._product.options.findIndex(
        option => option.toLowerCase() === 'size'
      );
      let colorOptionIndex = this._product.options.findIndex(
        option => option.toLowerCase() === 'color'
      );
      // If color option filter variants by selected color
      if (this._selectedColor) {
        variants = this._product.variants.filter(
          variant =>
            variant[`option${colorOptionIndex + 1}`] === this._selectedColor
        );
      }
      variants.forEach(variant => {
        let title = variant.title;
        // If option is size use option name, else use variant name
        if (sizeOptionIndex >= 0 && colorOptionIndex >= 0)
          title = variant[`option${sizeOptionIndex + 1}`];
        optionButtons.push(`
          <a role="button" title="${title}" class="option" data-product-title="${
          this._product.title
        }" data-product-price="${(this._product.price / 100).toFixed(
          2
        )}" data-variant-id="${variant.id}" data-option data-available="${
          variant.available
        }">${title}</a>
        `);
        if (hasOneSizeOption || onlyHasColorOption) {
          const button = `
          <a role="button" title="add to bag" aria-label="add to bag"
           class="add-to-cart" data-product-title="${this._product.title}" data-variant-id="${variant.id}" data-option data-available="${variant.available}">+</a>
        `;
          // mobile atc
          this.querySelector('.product-card__cta').innerHTML = button;
        }
      });
    }

    // Add options to form for desktop
    this.querySelector('.product-card__options').innerHTML =
      optionButtons.join('');
    // If not single variant add messaging
    if (this._product.variants.length > 1) {
      const parent = this.querySelector('.product-card__options');
      const p = document.createElement('p');
      p.classList.add('choose');
      p.innerHTML =
        optionButtons.length === 1
          ? 'Add To Bag'
          : 'Choose Option To Add To Bag';
      parent.insertBefore(p, parent.firstChild);
      if (!hasOneSizeOption && !onlyHasColorOption)
        // mobile
        this.querySelector('.product-card__cta').innerHTML = `
          <a role="button" aria-label="open the modal to choose size" title="Add To Bag" class="add-to-cart" data-modal-trigger data-product-title="${this._product.title}">+</a>
        `;
    }

    // Add add to cart on click event
    this.querySelectorAll('[data-option]').forEach(option =>
      option.addEventListener('click', this.addToCart)
    );
    this.querySelector('[data-modal-trigger]')?.addEventListener(
      'click',
      event => {
        event.preventDefault();
        event.stopPropagation();
        window.toggleModal('product-modal', {
          product: this._product,
          collections: this._productCollections,
          color: this._selectedColor
        });
      }
    );
  }
  addToCart(e) {
    e.preventDefault();
    const element = e.target.closest('[data-option]');
    if (element.dataset.available === 'true') {
      const variantId = element.dataset.variantId;
      const options = {
        id: variantId,
        quantity: 1,
        option: element.innerText
      };
      BOLD.BMS.QuickCart.addItemToCart(options, element);

      if (this._product) {
        let klaviyoItem = {
          Name: String(this._product.title),
          ProductID: this._product.id,
          Categories: this._productCollections || this._product.collections,
          ImageURL: `https:${this._product.images[0]}`,
          URL: `https://store.barstoolsports.com/products/${this._product.handle}`,
          Brand: String(this._product.vendor),
          Tags: this._product.tags
        };
        _learnq.push(['track', 'Added to Cart', klaviyoItem]);
      }
    }
  }
}

function mapGqlProductToProduct(gqlProduct) {
  let product = {};
  product.title = gqlProduct.title;
  product.images = gqlProduct?.images?.nodes?.map(image => image.url);
  product.vendor = gqlProduct?.vendor;
  product.collections = gqlProduct?.collections?.nodes.map(
    collection => collection.title
  );
  product.options = gqlProduct?.options
    ? gqlProduct?.options?.map(option => option.name)
    : [];
  product.tags = gqlProduct.tags;
  product.price = gqlProduct?.priceRange?.maxVariantPrice
    ? Number(gqlProduct?.priceRange?.maxVariantPrice?.amount) * 100
    : 0;
  product.compare_at_price =
    gqlProduct?.compareAtPriceRange?.minVariantPrice?.amount === '0.0'
      ? null
      : Number(gqlProduct?.compareAtPriceRange?.minVariantPrice?.amount) * 100;
  product.variants = gqlProduct?.variants?.nodes.map(variant => {
    return {
      id: variant.id.split('gid://shopify/ProductVariant/')[1],
      available: variant.availableForSale,
      title: variant.title,
      featured_image: {
        src: variant.image?.url
      },
      options: variant.selectedOptions.map(option => option.name),
      option1: variant.selectedOptions[0]?.value,
      option2: variant.selectedOptions[1]?.value,
      option3: variant.selectedOptions[2]?.value
    };
  });
  return product;
}

customElements.define('product-card', ProductCard);
